// Indian states and union territories. `code` is the standard 2-letter state code already used across
// this app's existing data (e.g. "KA" for Karnataka, "TG" for Telangana) — this is what gets stored as
// the record's State Code. `gstCode` is the official 2-digit GST state code — the same digits every
// GSTIN issued in that state starts with — used only to auto-fill the leading digits of a GSTIN field.
export const INDIAN_STATES = [
  { name: "Jammu and Kashmir", code: "JK", gstCode: "01" },
  { name: "Himachal Pradesh", code: "HP", gstCode: "02" },
  { name: "Punjab", code: "PB", gstCode: "03" },
  { name: "Chandigarh", code: "CH", gstCode: "04" },
  { name: "Uttarakhand", code: "UK", gstCode: "05" },
  { name: "Haryana", code: "HR", gstCode: "06" },
  { name: "Delhi", code: "DL", gstCode: "07" },
  { name: "Rajasthan", code: "RJ", gstCode: "08" },
  { name: "Uttar Pradesh", code: "UP", gstCode: "09" },
  { name: "Bihar", code: "BR", gstCode: "10" },
  { name: "Sikkim", code: "SK", gstCode: "11" },
  { name: "Arunachal Pradesh", code: "AR", gstCode: "12" },
  { name: "Nagaland", code: "NL", gstCode: "13" },
  { name: "Manipur", code: "MN", gstCode: "14" },
  { name: "Mizoram", code: "MZ", gstCode: "15" },
  { name: "Tripura", code: "TR", gstCode: "16" },
  { name: "Meghalaya", code: "ML", gstCode: "17" },
  { name: "Assam", code: "AS", gstCode: "18" },
  { name: "West Bengal", code: "WB", gstCode: "19" },
  { name: "Jharkhand", code: "JH", gstCode: "20" },
  { name: "Odisha", code: "OD", gstCode: "21" },
  { name: "Chhattisgarh", code: "CG", gstCode: "22" },
  { name: "Madhya Pradesh", code: "MP", gstCode: "23" },
  { name: "Gujarat", code: "GJ", gstCode: "24" },
  { name: "Dadra and Nagar Haveli and Daman and Diu", code: "DN", gstCode: "26" },
  { name: "Maharashtra", code: "MH", gstCode: "27" },
  { name: "Karnataka", code: "KA", gstCode: "29" },
  { name: "Goa", code: "GA", gstCode: "30" },
  { name: "Lakshadweep", code: "LD", gstCode: "31" },
  { name: "Kerala", code: "KL", gstCode: "32" },
  { name: "Tamil Nadu", code: "TN", gstCode: "33" },
  { name: "Puducherry", code: "PY", gstCode: "34" },
  { name: "Andaman and Nicobar Islands", code: "AN", gstCode: "35" },
  { name: "Telangana", code: "TG", gstCode: "36" },
  { name: "Andhra Pradesh", code: "AP", gstCode: "37" },
  { name: "Ladakh", code: "LA", gstCode: "38" },
];
